export const sendonboardingmail =   `mutation SendOnboardingMail($input: SendOnboardingMailInput!) {
        SendOnboardingMail(input: $input) {
          success
          message
        }
      }`
export const assetrequest = `
mutation SendAssetRequestMail($assetRequest: AssetRequestInput!) {
  SendAssetRequestMail(assetRequest: $assetRequest) {
    success
    message
  }
}

`

export const updaterecruitmentproceesdata = `
 mutation UpdateRecruitmentProcess($id: ID!, $input: RecruitmentProcessInput!) {
        updateRecruitmentProcess(id: $id, input: $input) {
          recruitmentProcess {
            id
            screening
            technicalInterview
            interviewStatus
            offerLetter
            onBording
            assertRequest
            documentVerification
            appointmentLetter
            nda
            hrInduction
            technicalInduction
            teamIntro
            assestHandover
            hrmsAccess
            handoverToManager
          }
          success
          message
        }
      }
`

export const generateappointment = `
mutation CreateAppointmentLetter( 

  $input: CreateAppointmentLetterInput! 

) { 

  createAppointmentLetter(input: $input) { 

    empCode 

    date 

    ctc 

    gross 

    totalDeductions 

    totalBenefits 

    netPay 

    overallSum 

    difference 

    breakdown    

  } 

}
`